import { closePopup } from '@/popups/popup';

export function popupLectorInit() {
  /*$('.popup-lector-accept').on('click', () => {
    /!*todo действия при подтверждении*!/
  });

  $('.popup-lector-dismiss').on('click', () => {
    closePopup($('#popup-lector'));
    $('.lector-checkbox').prop('checked', false).trigger('change');
  });*/
}
